const TIMELINE = 'TIMELINE';
const ADD_TIMELINE = 'ADD_TIMELINE';
const SET_SELECTED_STEP = 'SET_SELECTED_STEP';

export { TIMELINE, ADD_TIMELINE, SET_SELECTED_STEP };



// WEBPACK FOOTER //
// ./src/store/Timeline/types.js